import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "dialog-card"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "section-title" }, "Payment", -1)
const _hoisted_3 = { class: "payment-method__card" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "medium" }
const _hoisted_6 = { class: "capitalize" }
const _hoisted_7 = { class: "mt-3 gap-1 payment-method__actions" }
const _hoisted_8 = {
  key: 1,
  class: "dialog-card payment-method"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "title mb-2" }, "Please add a payment card", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "description mb-3" }, "By adding a card, you can pay for purchases within the platform and automatically renew subscriptions", -1)
const _hoisted_11 = { class: "mt-4 gap-1" }
const _hoisted_12 = ["src"]

import { ref } from 'vue';
import { useBillingStore } from '@/stores/billing';
import dayjs from 'dayjs';
import AddCircleIcon from './icons/actions/AddCircleIcon.vue';
import VButton from './VButton.vue';

import icon1 from '@/assets/cards/master-card.svg'
import icon2 from '@/assets/cards/visa.svg'
import icon3 from '@/assets/cards/american-express.svg'
import icon4 from '@/assets/cards/jsb.svg'
import icon5 from '@/assets/cards/discover.svg'
import icon6 from '@/assets/cards/union-pay.svg'
import icon7 from '@/assets/cards/diners.svg'


export default /*#__PURE__*/_defineComponent({
  __name: 'PaymentMethod',
  setup(__props) {

const billingsStore = useBillingStore()

const pendingAdd = ref(false)

const addNew = async () => {
  pendingAdd.value = true
  try {
    await billingsStore.addCard()
  } finally {
    pendingAdd.value = false
  }
}

const pendingRemove = ref(false)
const removeSub = async () => {
  pendingRemove.value = true
  try {
    await billingsStore.cancelSubscription()
  } finally {
    pendingRemove.value = false
  }
}

const cards: Record<string, string> = {
  "master-card": icon1,
  "visa": icon2,
  "american-express": icon3,
  "jsb": icon4,
  "discover": icon5,
  "union-pay": icon6,
  "diners": icon7,
}

const cardInfo = (card: { exp_month: string, exp_year: string }, fullName: string) => {
  if (!card || !card.exp_month || !card.exp_year) return ""
  const exp_month = card.exp_month.toString()
  const exp_year = card.exp_year.toString()
  return `Expires ${"00".slice(exp_month.length)+exp_month}/${exp_year.slice(2)} - ${fullName.toUpperCase()}`
}


return (_ctx: any,_cache: any) => {
  return (_unref(billingsStore).cardInfo)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("img", {
            src: cards[_unref(billingsStore).cardInfo.card.brand],
            height: "30"
          }, null, 8, _hoisted_4),
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(billingsStore).cardInfo.card.brand), 1),
              _createTextVNode(" ****" + _toDisplayString(_unref(billingsStore).cardInfo.card.last4), 1)
            ]),
            _createElementVNode("div", null, _toDisplayString(cardInfo(_unref(billingsStore).cardInfo.card, _unref(billingsStore).cardInfo.full_name)), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(VButton, {
            secondary: "",
            disabled: pendingAdd.value,
            onClick: addNew
          }, {
            default: _withCtx(() => [
              _createTextVNode("Update")
            ]),
            _: 1
          }, 8, ["disabled"]),
          _createVNode(VButton, {
            secondary: "",
            red: "",
            disabled: pendingRemove.value,
            onClick: removeSub
          }, {
            default: _withCtx(() => [
              _createTextVNode("Cancel Subscription")
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_8, [
        _hoisted_9,
        _hoisted_10,
        _createVNode(VButton, {
          onClick: addNew,
          disabled: pendingAdd.value,
          class: "payment-method__button"
        }, {
          default: _withCtx(() => [
            _createVNode(AddCircleIcon),
            _createTextVNode("Add card")
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createElementVNode("div", _hoisted_11, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(cards, (cardSrc) => {
            return _createElementVNode("img", {
              src: cardSrc,
              width: "36"
            }, null, 8, _hoisted_12)
          }), 64))
        ])
      ]))
}
}

})